<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md7 lg8 xs12 sm11>
        <!-- video -->
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Diagnóstico Estratégico.</h4>
              <p
                class="pull"
              >El Diagnóstico Estratégico comprende los resultados de un proceso altamente participativo a nivel institucional, donde la comunidad universitaria ha evaluado los avances respecto a la actual carta de navegación y se ha proyectado a los desafíos de la próxima década. Con la aplicación de encuestas, grupos focales, talleres de trabajo, revisión de informes secundarios y plataformas virtuales, se desarrollan tres dimensiones: institucional, departamental y prospectiva.</p>
            </v-flex>
          </v-layout>
          <iframe
            class="video"
            :src="linkVideo"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-flex>
      </v-flex>

      <v-flex md1.5 lg xs0 sm0 hidden-sm-and-down>
        <v-navigation-drawer floating permanent stateless class="drawner" value="true">
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(1)"
                  >Presentación resumida</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(23)"
                  >Diagnóstico estratégico</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-navigation-drawer floating permanent stateless class="drawner2" value="true">
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(1)"
                  >Presentación resumida</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../assets/Captura2.png";
export default {
  data() {
    return {
      linkVideo: "",
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDca: "",
      img1: img1,
      items: [
        { title: "° Video", icon: "dashboard", path: "1" },
        {
          title: "° Lineamientos Estratégicos",
          icon: "dashboard",
          path: "2"
        },
        { title: "° Diagnostico", icon: "question_answer", path: "3" },
        { title: "° Planes Operativos", icon: "question_answer", path: "4" },
        { title: "° Indicadores", icon: "question_answer", path: "5" },
        { title: "° Focus Group", icon: "question_answer", path: "6" }
      ],
      right: null
    };
  },
  created() {
    //console.log(this.$session.getAll().ccData);
    axios
      .get(
        process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
        this.auth
      )
      .then(response => {
        this.filesDca = response.data;
        //console.log(this.filesDca);
        //console.log(this.filesDca["dge"][1]);
      })
      .catch(error => {
        console.error(error);
      });

    axios
      .get(
        process.env.ROOT_API +
          "/centrocosto/getLinkVideoCentroMayor?ccValor=" +
          this.$session.getAll().ccData.ccValor,
        this.auth
      )
      .then(response => {
        this.linkVideo = response.data;
        //console.log(this.filesDca);
        //console.log(this.filesDca["dge"][1]);
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    redirect(index) {
      this.typeEstrategico = index;
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDca.dge[index]["path"]);
      var nameFile = this.filesDca.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>


<style scoped>
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.v-list-new {
  height: 100% !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #f1f1f1 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/Video.vue